import axios from "axios";

/**
 * Resolve the backend base URL.
 *
 * Priority:
 *   1. In a browser, always use the current origin (window.location.origin).
 *      The Kubernetes ingress proxies "/api" → backend, so same-origin is
 *      both safe and immune to preview-URL drift.
 *   2. Outside the browser (SSR / tests / scripts), fall back to
 *      REACT_APP_BACKEND_URL. This must be the full origin (no trailing slash).
 */
const resolveBackendOrigin = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || "";
};

export const BACKEND_ORIGIN = resolveBackendOrigin();
export const API_BASE = `${BACKEND_ORIGIN}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});
